// extracted by mini-css-extract-plugin
export var aircallIframe = "_jt-3";
export var fabContainer = "_jt-5";
export var fabRinging = "_jt-6";
export var loadingOverlay = "_jt-4";
export var pulse = "_jt-7";
export var widgetContent = "_jt-2";
export var widgetPanel = "_jt-0";
export var widgetPanelExpanded = "_jt-1";